//报错自定义对象
let errorType = []

export const sentryIngnoreData = [
  // 忽略列表
  '-103',
  '-204', // 信息发送超过限制
  '-202', // 信息加载失败,请重试
  '-219', // 订单状态错误
  '-220', // 验证码错误
  '-237', // 此站点没有该商品
  '-300', // 您无权限访问此站点
  '-214', // 重复提交
  '-236', // 密码错误
  '-245', // 此地址未在同城配送范围内，请更改地址或取消选择同城配送
  '-206', // 参数不全
  '-307', // 请先绑定积分卡，否则不能浏览商品
  'TRIM_MEMORY_RUNNING_CRITICAL', // 内存不足
  'TRIM_MEMORY_RUNNING_LOW', // 内存不足
  '内存不足告警',
  'request:fail 请求超时',
  'request:ok',
  'request:fail timeout',
  "hideLoading:fail:toast can't be found",
  'o.overflowY',
  'overflowY',
  'a.overflowY',
  'reload',
  'webviewScriptError',
  'getGlobalWebviewIds',
  'ICBCInitTools', // 工商银行
  'YHAuthorize',
  'muscStop', // 中信银行webview报错
  'closeBtnCallback', // 中信银行webview报错
  'onPageResume', // 中信银行webview报错
  'insertAdjacentHTML', // 江苏紫金农村商业银行股份有限公司 QQ浏览器报错
  "Can't find variable: __api__",
  'Cannot find variable: __api__',
  'Non-Error exception captured with keys: currentTarget, detail, isTrusted, target',
  "Cannot read property 'scrollTop' of undefined",
  'exceptionUploader.reportJSException is not a function',
  "Can't find variable: api",
  'Cannot find variable: api',
  "Unexpected identifier 'window'",
  '{"isTrusted":false}',
  'c.children',
  'children',
  'Failed to fetch',
  'transition',
  'h.$wrapperEl.transition',
  '定位超时',
  'Unexpected identifier',
  'Actions must be plain objects. Use custom middleware for async actions.',
  'Non-Error promise rejection captured with value: undefined',
  'Non-Error promise rejection captured with keys: errMsg',
  "Cannot read property 'src' of undefined",
  'Load failed',
  'far <= 0',
  "undefined is not an object (evaluating 'window.webkit.messageHandlers')",
  "Can't find variable: __api__",
  "Can't find variable: WeixinJSBridge",
  "Can't find variable: WeixinJSBridge",
  'Cannot find variable: WeixinJSBridge',
  "Can't find variable: motionShakeDone",
  'Cannot find variable: motionShakeDone',
  "Cannot read property 'nodeValue' of undefined",
  `Can't find variable: objectInnerText`,
  `Loading chunk`,
  `Loading CSS`,
  'f is not a function',
  `reading 'id'`,
  'finally is not a function',
]

//报错分类
export function errorClassify(value) {
  let arr = errorType
    ?.filter(ele => value?.indexOf(ele?.sign) !== -1)
    ?.map(ele => {
      //中文解释 替换对应词语为中文，如count is not defined 替换后 count 变量未定义

      return {
        ...ele,
        explanation: value?.replace(ele?.sign, ele?.typeName),
      }
    })

  if (arr?.length > 0) {
    return arr[0]
  }

  return {
    sign: '',
    level: '待定义',
    typeName: '',
    explanation: '',
    resolve: '',
  }
}
